import { render, staticRenderFns } from "./dataStatistics.vue?vue&type=template&id=a0b9432a&scoped=true"
import script from "./dataStatistics.vue?vue&type=script&lang=js"
export * from "./dataStatistics.vue?vue&type=script&lang=js"
import style1 from "./dataStatistics.vue?vue&type=style&index=1&id=a0b9432a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b9432a",
  null
  
)

export default component.exports